const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const { GET_PRODUCTS_LIST, GET_PRODUCT } = require("./constants");

const {
  productSuccess,
  productError,

  productsListSuccess,
  productsListError,
} = require("./actions");

const productsList = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PRODUCTS_LIST),
    mergeMap((action) =>
      marketplaceApi.marketBusinessCatalogue
        .lists(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
        })
        .then((response) => productsListSuccess(response.data))
        .catch((error) => productsListError(error))
    )
  );

const getProduct = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PRODUCT),
    mergeMap((action) =>
      marketplaceApi.marketCustomerCatalogue
        .product(marketplace, action.payload.uuid)
        .then((response) => productSuccess(response.data))
        .catch((error) => productError(error))
    )
  );

module.exports = {
  productsList,
  getProduct,
};
